<template>
    <div class="main">
        <form-ficha-saude :alunoId="$route.params.aluno_id"></form-ficha-saude>
    </div>
</template>

<script>
import formFichaSaude from './form'

export default {
    components: { 'form-ficha-saude': formFichaSaude }
}
</script>

